import { render } from "./FranchiseMenu.vue?vue&type=template&id=2d771eca&scoped=true&ts=true"
import script from "./FranchiseMenu.vue?vue&type=script&lang=ts"
export * from "./FranchiseMenu.vue?vue&type=script&lang=ts"

import "./FranchiseMenu.vue?vue&type=style&index=0&id=2d771eca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d771eca"]])

export default __exports__